import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { LogoMark } from '../components/Logo';
import { MIRROR_AI_COUPLE, MIRROR_AI_TEAM } from '../data/mock';
import { Sparkles, Cpu, Users } from 'lucide-react';

export default function MirrorAI() {
  return (
    <main className="pt-32">
      <section className="relative bg-[#042f38] text-[#faf4ea] py-24 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.08]" style={{background:'radial-gradient(circle at 70% 30%, #c3a66d 0%, transparent 50%)'}} />
        <div className="relative max-w-[1240px] mx-auto px-6 md:px-10">
          <div className="flex items-center gap-4"><LogoMark size={44} /><span className="eyebrow text-[#c3a66d]">Mirror AI — Coming Soon</span></div>
          <Heading dark className="mt-6 font-serif max-w-4xl">Intelligence for the planning.<br/><span className="italic text-[#ffeabf]">Humans for the wedding.</span></Heading>
          <p className="mt-6 max-w-2xl text-[#d8d0bf] leading-relaxed text-lg">Mirror AI is Sunday Mirror’s future planning assistant—designed to make destination-wedding planning clearer, faster and better organised while your dedicated human team remains in control.</p>
        </div>
      </section>

      <section className="bg-[#faf4ea] py-24">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-10">
          <div className="p-10 border border-[#e8e0d2] bg-white">
            <div className="flex items-center gap-3"><Users size={20} className="text-[#c3a66d]" /><div className="eyebrow text-[#a6894f]">For Couples</div></div>
            <h3 className="mt-4 font-serif text-3xl text-[#053e49]">Plan with clarity, not chaos.</h3>
            <ul className="mt-6 space-y-3">{MIRROR_AI_COUPLE.map((i) => (<li key={i} className="flex gap-3 text-[#4a5c60]"><Sparkles size={14} className="text-[#c3a66d] mt-1" /><span>{i}</span></li>))}</ul>
          </div>
          <div className="p-10 border border-[#e8e0d2] bg-white">
            <div className="flex items-center gap-3"><Cpu size={20} className="text-[#c3a66d]" /><div className="eyebrow text-[#a6894f]">For the Sunday Mirror Team</div></div>
            <h3 className="mt-4 font-serif text-3xl text-[#053e49]">Faster workflows. Better service.</h3>
            <ul className="mt-6 space-y-3">{MIRROR_AI_TEAM.map((i) => (<li key={i} className="flex gap-3 text-[#4a5c60]"><Sparkles size={14} className="text-[#c3a66d] mt-1" /><span>{i}</span></li>))}</ul>
          </div>
        </div>
      </section>

      <section className="bg-[#053e49] text-[#faf4ea] py-24">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
          <SectionLabel align="center" dark>The Principle</SectionLabel>
          <p className="mt-6 font-serif italic text-2xl md:text-3xl text-[#ffeabf]">AI can organise information, surface options and save time. Human planners remain responsible for judgment, relationships, negotiation, hospitality and live wedding execution.</p>
          <div className="hairline mt-10 max-w-xs mx-auto" />
          <p className="mt-10 font-serif text-xl text-[#c3a66d]">Mirror AI supports your planner. It never replaces one.</p>
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
